import React, {Component} from 'react'
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
import propTypes from 'prop-types'
import {isNil} from "lodash"
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Icon, {iconNames} from 'components/icon'
import ListSubheader from '@material-ui/core/ListSubheader'
import SearchBar from 'components/searchBar'
import {prefix} from 'helpers/component'
import {parseCssSelector} from "helpers/css"

require('./sortableFieldPicker.scss')
const getClassName = prefix('sortableFieldPicker-')

const FieldChoice = SortableElement((props) => {
  const {field, onSelect} = props
  const {alias, active, mandatory, selectable} = field
  let {label} = field

  label = label || alias

  const checked = active || mandatory

  return (
    <MenuItem
      className={parseCssSelector(label)}
      disabled={selectable === false || mandatory}
      onClick={() => onSelect(field, !checked)}
    >
      <ListItemIcon>
        <Icon name={iconNames.tick} style={checked ? null : {visibility: 'hidden'}}/>
      </ListItemIcon>
      {mandatory ? <>{label} *</> : label}
    </MenuItem>
  )
})

FieldChoice.propTypes = {
  field: propTypes.shape({
    label: propTypes.string,
    alias: propTypes.string,
    active: propTypes.bool,
    mandatory: propTypes.bool,
    selectable: propTypes.bool,
  }).isRequired,
  onSelect: propTypes.func.isRequired,
}

const FieldList = SortableContainer((props) => {
  const {fields, sortable = true, onSelect} = props

  return (
    <div>
      {fields.map((f, index) => {
        const key = f.key || f.label
        return (
          <FieldChoice
            key={key}
            index={index}
            field={f}
            disabled={!sortable}
            onSelect={onSelect}
          />
        )
      })}
    </div>
  )
})

FieldList.propTypes = {
  fields: propTypes.arrayOf(FieldChoice.propTypes.field).isRequired,
  onSelect: propTypes.func,
  sortable: propTypes.bool,
}

class SortableFieldPicker extends Component {
  state = {
    searchTerm: null,
  }

  search = (searchTerm) => {
    this.setState({searchTerm})
  }

  sortEnd = ({oldIndex, newIndex}) => {
    const {fields, onMove} = this.props
    const field = fields[oldIndex]
    if (field) {
      onMove(field, oldIndex, newIndex)
    }
  }

  getTitle = () => {
    const {title} = this.props

    if (!isNil(title)) {
      return (
        <div className={getClassName('title')}>
          <ListSubheader style={{paddingLeft: '16px'}}>
            {title}
          </ListSubheader>
        </div>
      )
    }
  }

  getSearch = () => {
    const {searchable = false} = this.props
    if (searchable) {
      return (
        <div className={getClassName('search')}>
          <SearchBar onSearch={this.search}/>
        </div>
      )
    }
  }

  getMenu = () => {
    const {onSelect} = this.props
    let {fields} = this.props
    let {searchTerm} = this.state

    let sortable = true
    if (searchTerm && searchTerm.length > 0) {
      searchTerm = searchTerm.toLowerCase()
      fields = fields.filter(f => f.label.toLowerCase().indexOf(searchTerm) >= 0)
      sortable = false
    }

    return (
      <div className={getClassName('menu')}>
        <MenuList>
          <FieldList
            fields={fields}
            sortable={sortable}
            lockAxis="y"
            distance={10}
            helperClass={getClassName('sortable-helper')}
            useWindowAsScrollContainer
            onSelect={onSelect}
            onSortEnd={this.sortEnd}
          />
        </MenuList>
      </div>
    )
  }

  getResetButton = () => {
    const {onResetColumnsToDefault} = this.props

    return (
      <div className={getClassName('reset')}>
        <MenuItem onClick={onResetColumnsToDefault}>
          Reset to default
        </MenuItem>
      </div>
    )
  }

  render() {
    return (
      <div className={getClassName('container')}>
        {this.getTitle()}
        {this.getSearch()}
        {this.getMenu()}
        {this.getResetButton()}
      </div>
    )
  }
}

SortableFieldPicker.propTypes = {
  title: propTypes.node,
  fields: propTypes.arrayOf(FieldChoice.propTypes.field).isRequired,
  onSelect: propTypes.func,
  searchable: propTypes.bool,
  onMove: propTypes.func,
  onResetColumnsToDefault: propTypes.func,
}

export default SortableFieldPicker
